export default "__VITE_ASSET__DB0IktOy__"